export type Bonus = {
  number: number;
  title: string;
  value: number;
  image: string;
  tagline: string;
  intro: string;
  items: string[];
  why: string;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "Diabetic Foot Quick-Reference Cards",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/d8E4zPy8C4mJBhZE7eh1wq/BONUS_1_FOOT-EN.png",
    tagline: "Review important assessment concepts with a compact visual reference collection.",
    intro:
      "When you want to revisit a particular topic, it can be helpful to have the key concepts organized into concise reference cards. This resource brings together reminders and educational summaries related to common assessment domains.",
    items: [
      "Foot inspection reference cards.",
      "Sensory assessment reminders.",
      "Circulatory assessment considerations.",
      "Skin and nail finding summaries.",
      "Wound observation reminders.",
      "Diabetic foot risk factor review cards.",
      "Potential warning signs.",
      "Documentation reminders.",
      "Footwear considerations.",
      "Referral and follow-up review prompts.",
    ],
    why: "To give you a concise supplementary resource for reviewing important concepts alongside the six main volumes.",
  },
  {
    number: 2,
    title: "The Diabetic Foot Assessment Checklist",
    value: 12,
    image: "https://cdn.magicpatterns.com/uploads/mxYDZKQuPsrWcAvjhrJLpj/BONUS_2_FOOT-EN.png",
    tagline: "Use a structured checklist to organize the main components of your assessment.",
    intro: "This practical resource brings the major assessment domains together in a checklist format.",
    items: [
      "Patient history review.",
      "Previous ulceration and amputation history.",
      "General foot inspection.",
      "Skin and nail observations.",
      "Sensory assessment documentation.",
      "Circulatory assessment documentation.",
      "Foot deformity and pressure-related observations.",
      "Footwear and self-care considerations.",
      "Risk factor summary.",
      "Findings requiring further evaluation.",
      "Documentation review.",
      "Follow-up and referral notes.",
    ],
    why: "To help you organize the information you review and identify areas that may need further assessment or documentation.",
  },
  {
    number: 3,
    title: "The Foot Findings Differential Reference",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/arHr41oCfTpAbcqQQ5sGhe/BONUS_3_FOOT-EN.png",
    tagline: "Compare common foot findings and organize the questions they may raise.",
    intro:
      "Different foot conditions can share similar visible characteristics. This educational reference focuses on describing findings, considering possible explanations, and recognizing when further evaluation may be necessary.",
    items: [
      "Calluses and other pressure-related changes.",
      "Corns and plantar lesions.",
      "Skin fissures and integrity changes.",
      "Nail abnormalities.",
      "Wound appearance categories.",
      "Findings that may suggest infection.",
      "Circulation-related observations.",
      "Examples of overlapping clinical presentations.",
      "Questions to consider when information is incomplete.",
      "Documentation reminders for observed findings.",
    ],
    why: "To help you approach visual findings more systematically without assuming that appearance alone establishes a diagnosis.",
  },
  {
    number: 4,
    title: "Diabetic Foot Clinical Case Practice Pack",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/6iJVg2wqEQ1Qp2j3pRmfhR/BONUS_4_FOOT-EN.png",
    tagline: "Reinforce your knowledge with additional educational case exercises.",
    intro:
      "This supplementary case pack gives you more opportunities to practice organizing clinical information and identifying questions that may require further assessment.",
    items: [
      "Patient history review scenarios.",
      "Sensory assessment exercises.",
      "Circulatory finding review cases.",
      "Skin and nail observation scenarios.",
      "Wound documentation exercises.",
      "Risk factor identification activities.",
      "Cases involving multiple findings.",
      "Guided clinical reasoning questions.",
      "Documentation practice prompts.",
      "Reflection exercises for identifying information gaps.",
    ],
    why: "To complement the sixth volume with additional opportunities to review assessment concepts through case-based learning.",
  },
  {
    number: 5,
    title: "Diabetic Foot Documentation and Follow-Up Template Collection",
    value: 12,
    image: "https://cdn.magicpatterns.com/uploads/u7vMR8G2uZy3Cj1VR8ahnX/BONUS_5_FOOT-EN.png",
    tagline: "Organize your observations and follow-up notes with dedicated templates.",
    intro:
      "Clear documentation helps communicate relevant findings and provides a structured record of what was assessed. This collection brings together adaptable template concepts for organizing the information covered throughout the blueprint.",
    items: [
      "Patient history summary template.",
      "General foot examination template.",
      "Skin and nail observation template.",
      "Sensory assessment record.",
      "Circulatory assessment record.",
      "Wound description template.",
      "Risk factor summary sheet.",
      "Clinical findings and concerns record.",
      "Referral communication preparation template.",
      "Follow-up observation sheet.",
      "Clinical note review checklist.",
    ],
    why: "To give you practical starting points for organizing documentation and follow-up information in accordance with your professional and institutional requirements.",
  },
];
